import { addQueryParametersToUrl } from "@/helper/query-params/add-query-params-to-url.util";
import { Constants } from "@/services/web/api.const";
import { READ_ORDERS_SCOPE } from "@/modules/finance/helper/constants/api-payment-history.const";
import { auth0Config } from "@/configs/auth-config";
import { useApi } from "@/services/web/use-api";
import { OrdersSummary } from "@/types/orders-summary.type";
import { formatRangeDate } from "@/helper/date-time";

export const useOrdersSummary = (cityId: string | undefined | null, startDate: Date, endDate: Date) => {
  let params: Record<string, unknown> = {};

  if (startDate && endDate) {
    const { startDate: start_date, endDate: end_date } = formatRangeDate(startDate, endDate);

    params = {
      ...params,
      start_date,
      end_date,
    };
  }

  if (cityId) {
    params = {
      ...params,
      cityId,
    };
  }

  let url = `${Constants.CLIENTS_API_URL}/orders/total`;
  url = addQueryParametersToUrl(url, params);
  const {
    isLoading: loading,
    error,
    data,
  } = useApi<OrdersSummary>(url, {
    method: "GET",
    audience: auth0Config.clientAudiance,
    scope: READ_ORDERS_SCOPE,
  });

  return {
    loading,
    error,
    data,
  };
};
